import api from '../services/api';
import { EncryptStorage } from 'encrypt-storage';

export const encryptStorage = EncryptStorage('secret_key', {
    prefix: '@prefix'
});

export async function changeUser(id){
    const response = (await api.get(`user/odata?$select=id, name, sap, email, SystemRoleId, Status, UserDirectSuperiorId, PhotoUrl&$expand=CompanyRole, factory, SystemRole&$filter=sap+eq+'${id}'`)).data.value[0]
    //const response = (await api.get(`user/${id}`)).data  
    console.log(response)
    let user = response

    encryptStorage.setItem('User', JSON.stringify(user));
    encryptStorage.setItem('SystemRole', JSON.stringify(user.systemRole));
    encryptStorage.setItem('SimulatingUser', 'true');
    console.log('change')
    return user.id
    // localStorage.setItem('UserReal', JSON.stringify(user));
    // localStorage.setItem('Factory', JSON.stringify(userAPIData['Factory']));
    // localStorage.setItem('SystemRole', JSON.stringify(userAPIData['SystemRole']));
    // localStorage.setItem('SystemRoleReal', JSON.stringify(userAPIData['systemRole']));
    // localStorage.setItem('CompanyRole', JSON.stringify(userAPIData['CompanyRole']));
}

export async function returnUser(){
    encryptStorage.setItem('User', encryptStorage.getItem('UserReal'))

    encryptStorage.setItem('SystemRole', encryptStorage.getItem('SystemRoleReal'))
    // localStorage.setItem('SystemRole', JSON.stringify(userAPIData['SystemRole']));
    // localStorage.removeItem('UserReal')
    encryptStorage.removeItem('SimulatingUser');
     window.location.reload()
    
}
// export { changeUser }